import axios from 'axios';

import { API_V2_URL } from 'src/shared/constants/api';
import { getAccessToken } from 'src/shared/utils/auth';
import { getLocale } from 'src/shared/utils/languages';
import { UserService } from 'src/store/auth/user-service';

const apiV2Agent = axios.create({
  baseURL: API_V2_URL,
  headers: {
    'content-type': 'application/json',
  },
});

apiV2Agent.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error?.response?.status === 401) {
      const accessToken = await UserService.updateToken();

      if (error?.config && accessToken) {
        return axios.request({
          ...error.config,
          headers: {
            ...error.config.headers,
            Authorization: `Bearer ${accessToken}`,
          },
        });
      }
    }

    return Promise.reject(error);
  },
);

apiV2Agent.interceptors.request.use((config) => {
  const accessToken = getAccessToken();

  Object.entries(config.headers).forEach(([headerName, headerValue]) => {
    config.headers.set(headerName, headerValue);
  });
  config.headers['accept-language'] = getLocale();

  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }

  return config;
});

export { apiV2Agent };
